export const isFeatureEnabled = (flagValue, defaultValue = true) => (
  typeof flagValue === 'boolean' ? flagValue : defaultValue
)

export const hasGpsIntegration = config => {
  const trackingServices = config?.trackingServices || {}
  const services = [
    trackingServices.konsalnet,
    trackingServices.solidSecurity,
    trackingServices.whatsGps,
  ]

  return services.some(service => service?.active === true || service?.isActive === true)
}

export const canShowFinancialAnalysis = config => isFeatureEnabled(
  config?.menu?.showFinancialAnalysis,
)

export const canShowSchedule = config => isFeatureEnabled(
  config?.menu?.showSchedule,
)

export const canShowPartners = config => isFeatureEnabled(
  config?.menu?.showPartners,
)

export const canShowMap = config => (config == null ? true : hasGpsIntegration(config))
